var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.soldOut)?_c('div',{staticClass:"availability row danger"},[_vm._v(_vm._s(_vm.$t('selectDate.buttonTooltip.sold_out')))]):(_vm.capacityThreshold)?_c('div',{class:_vm.classes},[_vm._v(_vm._s(_vm.formattedAvailability))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }